import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';
import PageFooter from './components/pageFooter';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import './CartPage.css';

export const CartPage = () => {
  const { cartItems, removeFromCart, updateQuantity, cartTotal } = useCart();

  if (cartItems.length === 0) {
    return (
      <PageLayout>
        <PageContainer>
          <PageBody>
            <NavigationHeader />
            <PageText>
              <div className="cart-empty">
                <p>your cart is empty</p>
                <Link to="/shop" className="cart-continue-link">continue shopping</Link>
              </div>
            </PageText>
            <PageFooter />
          </PageBody>
        </PageContainer>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <PageContainer>
        <PageBody>
          <NavigationHeader />
          <PageText>
            <div className="cart-container">
              <h2 className="cart-title">your cart</h2>
              {cartItems.map((item) => (
                <div key={item.id} className="cart-item">
                  <Link to={`/shop/${item.productId || item.id}`} className="cart-item-img-link">
                    <img src={item.image} alt={item.title} className="cart-item-image" />
                  </Link>
                  <div className="cart-item-details">
                    <p className="cart-item-name">{item.title}</p>
                    {item.options && (
                      <p className="cart-item-options">
                        {/* nail set options */}
                        {(item.options.size || item.options.shape || item.options.length) && (
                          <span>{[item.options.size, item.options.shape, item.options.length].filter(Boolean).join(' \u00b7 ')}</span>
                        )}
                        {/* nail commission options */}
                        {item.options.sizes && (
                          <span>{item.options.shape} \u00b7 {item.options.length}</span>
                        )}
                        {/* art commission options */}
                        {item.options.artType && (
                          <span>{item.options.artType}{item.options.size ? ` \u00b7 ${item.options.size}` : ''}</span>
                        )}
                        {item.options.rushOrder && <span> \u00b7 rush</span>}
                        {item.options.notes && <><br /><span className="cart-item-notes">note: {item.options.notes}</span></>}
                        {item.options.description && <><br /><span className="cart-item-notes">{item.options.description.slice(0, 60)}{item.options.description.length > 60 ? '...' : ''}</span></>}
                      </p>
                    )}
                    <p className="cart-item-price">${item.price.toFixed(2)}</p>
                    <div className="cart-item-quantity">
                      <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>−</button>
                      <span>{item.quantity}</span>
                      <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                    </div>
                  </div>
                  <button className="cart-item-remove" onClick={() => removeFromCart(item.id)}>
                    ✕
                  </button>
                </div>
              ))}
              <div className="cart-summary">
                <p className="cart-total">subtotal: ${cartTotal.toFixed(2)} USD</p>
                <p className="cart-shipping-note">
                  {cartTotal >= 50
                    ? '✧ free shipping'
                    : `+ $5.00 shipping (free over $50)`}
                </p>
                <Link to="/checkout" className="cart-checkout-btn">proceed to checkout</Link>
                <Link to="/shop" className="cart-continue-link">continue shopping</Link>
              </div>
            </div>
          </PageText>
          <PageFooter />
        </PageBody>
      </PageContainer>
    </PageLayout>
  );
};
